import { Link } from "react-router-dom";

export default function PageHero({ title, subtitle, image, crumbs = [] }) {
  return (
    <section className="relative overflow-hidden bg-[#0A0A0A] text-white" data-testid="page-hero">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/30" />
        </>
      )}
      <div className="container-px relative py-16 lg:py-24">
        <nav className="flex flex-wrap items-center gap-2 text-sm text-white/60" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <span>/</span>
              {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-white">{c.label}</span>}
            </span>
          ))}
        </nav>
        <h1 className="mt-5 max-w-3xl font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-balance">{title}</h1>
        {subtitle && <p className="mt-4 max-w-2xl text-lg text-white/70 leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
